<template>
    <div>
        <el-dialog
            :modal-append-to-body="false"
            title="讲解卡"
            :visible.sync="showPop"
            width="600px"
            class="upload_cover"
            align="left"
            @close="$emit('input',false)"
            >
                <div class="upload_dialog_content" style="min-width:600px">
                    <div class="upload_dialog_content_oper">
                        <el-button  @click="openFile">
                            <i class="iconfont">&#xe60f;</i>
                            <span style="margin-left: 6px">选择本地图片</span>
                        </el-button>
                    </div>
                    <div class="upload_cropper">
                        <div class="upload_cropper_con" :style="{'width': cropperW + 'px', 'height': cropperH+ 'px'}">
                            <cropper v-if="cropperFlag" :cropperUrl="cropperUrl" :ratio="ratio" :fileType="fileType" @coverFinsh="coverFinsh" :cropperW="cropperW" :cropperH="cropperH" @realTime="realTime" ref="cropper" ></cropper>
                            <span v-else>选择一张本地图片编辑后上传封面</span>
                        </div>
                        <div class="cover_preview_con">
                            <div class="cover_preview" :style="{'width': cropperW + 'px', 'height': cropperH+ 'px', 'zoom': 0.5}" >
                                <img :src="previewObj.url" alt="" v-if="Object.values(previewObj).length" :style="previewObj.img"/>
                            </div>
                            <span>格式支持{{accept.join('、')}}</span>
                        </div>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="$emit('input',false)">取 消</el-button>
                    <el-button type="primary" @click="sure">确 定</el-button>
                </div>
        </el-dialog>
        <input v-show="false" ref="fileIpt" type="file" @input="fileIptChange" :multiple="false" :accept="accept.join(',')">
        <uploadSmallFile ref="uploadSmallFileRef" @uploadSuccess="uploadSuccess" :maxSize="10" :showSuccessTip="true" uploadType="img" :accept="accept" @startUpload="startUpload"></uploadSmallFile>
    </div>
</template>

<script>
    import uploadSmallFile from '@/components/newUpload/uploadSmallFile.vue'
    import cropper from '@/components/cropper/cropper.vue'
    export default {
        components: {
            cropper,
            uploadSmallFile
        },
        props: {
            value:{
                type: Boolean,
                default: false
            },
            cropperW: {
                type: [Number, String],
                default: 220
            },
            cropperH: {
                type: [Number, String],
                default: 220
            },
            maxSize: { // 图片最大体积,单位mb
                type: Number,
                default: 10
            },
            ratio: {
                type: Array,
                default: () => [1, 1]
            },
            accept: {
                type: Array,
                default: () => [".jpg", ".png", ".jpeg", ".tif", ".jfif"],
            },
        },
        watch:{
            value(nval){
                this.showPop = nval
            }
        },
        data(){
            return {
                showPop: false,
                cropperFlag: false,
                fileType: '',
                previewObj: {},
                cropperUrl: '',
            }
        },
        methods: {
            openFile(){
                this.$refs.fileIpt.click()
            },
            realTime(obj) {
                this.previewObj = obj
            },
            // 点击 裁剪确定, 触发 -> coverFinsh
            sure() {
                this.$refs.cropper.uploadImg()
            },
            startUpload(){
                this.$message({
                    message: '开始上传...',
                    type: 'info',
                    duration: 2000
                })
            },
            // 选择图片文件
            async fileIptChange(e){
                // console.log("fileIptChange-e:",e.target.files[0])
                let file = e.target.files[0]
                let limitSize = this.maxSize // 最大限制
                if(file.size > limitSize*1024*1024){
                    this.tipMessage(`文件大小不能超过${limitSize}MB`)
                    return
                }
                this.picToCropper(file)
            },
            // 裁剪
            picToCropper(file){
                this.fileObj = file
                var reader = new FileReader()
                let that = this
                reader.onload = function(e) {
                    var img = new Image()
                    let url = ''
                    if (typeof e.target.result === 'object') {
                    url = window.URL.createObjectURL(new Blob([e.target.result]));
                    } else {
                    url = e.target.result;
                    }
                    img.src = url
                    that.cropperUrl = url
                    that.cropperFlag = true
                }
                if(!this.fileObj.url) {
                    reader.readAsArrayBuffer(file)
                } else {
                    that.cropperUrl = this.fileObj.url
                    that.cropperFlag = true
                }
            },
            // 完成裁剪
            async coverFinsh(url) {
                // console.log('coverFinsh-url:',url)
                const files = new File(
                    [url],
                    this.fileObj.name, {
                    type: url.type
                    }
                )
                // console.log('coverFinsh-files:',files)
                this.$refs.uploadSmallFileRef.uploadToOss(files)
                this.$emit('input', false)
            },
            // 上传成功
            uploadSuccess(e){
                this.$emit('uploadSuccess',e)
            },
            tipMessage(message, type="error", duration=3000) {
                this.$message({
                    type,
                    duration,
                    message
                })
            },
        }
    }
</script>

<style lang="less" scoped>
.upload_cropper {
  margin-top: 32px;
  display: flex;
  .upload_cropper_con {
    background-color: #f3f4f9;
    border: 1px dashed #c7cada;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    >span {
      width: 132px;
      font-size: 12px;
      color: #999;
      line-height: 17px;
      text-align: center;

    }
  }
  .cover_preview_con {
    margin-left: 40px;
    flex-shrink: 0;
    >span {
      font-size: 12px;
      color: #888a95;
      line-height: 17px;
    }
    .cover_preview {
      background-color: #f3f4f9;
      border: 1px dashed #c7cada;
      overflow: hidden;
      transform-origin: 0 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  
}
</style>